import type { MetaDescriptor } from 'react-router'
import { siteConfig } from './siteConfig'

const baseUrl = siteConfig.seo.baseUrl

export const DEFAULT_SOCIAL_IMAGE_PATH = '/images/og-default.png'

type MetaInput = {
  title: string
  description: string
  path?: string
  image?: string
  noindex?: boolean
}

export function buildMeta({
  title,
  description,
  path = '/',
  image = DEFAULT_SOCIAL_IMAGE_PATH,
  noindex = false,
}: MetaInput): MetaDescriptor[] {
  const canonicalUrl = new URL(path, baseUrl).toString()
  const imageUrl = new URL(image, baseUrl).toString()

  return [
    { title },
    { name: 'description', content: description },
    { tagName: 'link', rel: 'canonical', href: canonicalUrl },
    {
      name: 'robots',
      content: noindex
        ? 'noindex,nofollow'
        : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
    },
    { property: 'og:type', content: 'website' },
    { property: 'og:site_name', content: siteConfig.brand.academyName },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:url', content: canonicalUrl },
    { property: 'og:image', content: imageUrl },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:locale:alternate', content: 'bn_BD' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: imageUrl },
  ]
}
